import React, { Component, createRef } from 'react';
import ValidationText from '../../utils/validation/ValidationText.js';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import { CommonValidationMessages } from '../../utils/Messages.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import moment from 'moment';
import ItemMasterServices from '../../services/axioServices/apiServices/ItemMasterServices.js';
import { FinancealYearStartDateEndDate } from '../../utils/FinancialYearStartDateEndDate.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';
import { printFunction } from '../../components/print/printTemplate.js';

class AccountLedger extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.itemMasterServices = new ItemMasterServices();
        this.state = {
            companyName: '',
            tableStatus: "",
            accountLedgerList: [],
            totalCreditAmount: 0,
            totalDebitAmount: 0,
            closingBalance: 0,
            filterDetails: {
                startDate: "",
                endDate: "",
                partyId: "",
                openingBalance: "",
                email: "",
                telephone: "",
                mobileNo: "",
                openingBalanceDRCR: "",
            },
            partyDropdownList: [],
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        let dates = FinancealYearStartDateEndDate()
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = dates.startDate
        filterDetails.endDate = dates.endDate
        this.setState({ filterDetails: filterDetails })
        this.getAllPartyDropdown()
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }
    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                    transporterName: item.transporterName
                }));
                this.setState({ partyDropdownList: dropdownItems }

                );
            } else {

                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.startDate = ""
        Fdetails.endDate = ""
        Fdetails.partyId = ""
        Fdetails.openingBalance = ""
        Fdetails.email = ""
        Fdetails.telephone = ""
        Fdetails.mobileNo = ""
        this.setState({
            filterDetails: Fdetails,
            accountLedgerList: [],
            tableStatus: "",
            totalCreditAmount: 0,
            totalDebitAmount: 0,
            closingBalance: 0,
        });
    }
    getAllAccountLedger = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ tableStatus: "Loading..." }, () => {
                let request = this.state.filterDetails
                this.accountServices.getAllAccountLedger(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        let details = this.state.filterDetails
                        let accountLedgerList = this.calculateRunningBalance(Number(details.openingBalance), details.openingBalanceDRCR, response.responseData)
                        let totalCreditAmount = accountLedgerList.reduce((sum, item) => sum + Number(item.creditAmount), 0);
                        let totalDebitAmount = accountLedgerList.reduce((sum, item) => sum + Number(item.debitAmount), 0);
                        if (details.openingBalanceDRCR === 'Dr' || details.openingBalanceDRCR === 'DR') {
                            totalDebitAmount = totalDebitAmount + details.openingBalance
                        } else if (details.openingBalanceDRCR === 'Cr' || details.openingBalanceDRCR === 'CR') {
                            totalCreditAmount = totalCreditAmount + details.openingBalance
                        }
                        let balance = totalDebitAmount - totalCreditAmount
                        let finalBalance = Math.abs(balance);
                        let closingBalanceDRCR = balance >= 0 ? 'Dr' : 'Cr';
                        let closingBalance = finalBalance + ' ' + closingBalanceDRCR
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                        this.setState({ accountLedgerList: accountLedgerList, totalCreditAmount: totalCreditAmount, totalDebitAmount: totalDebitAmount, closingBalance: closingBalance })
                    } else {
                        this.setState({ tableStatus: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }

    calculateRunningBalance(openingBalance, openingBalanceDRCR, transactions) {
        let runningBalance = (openingBalanceDRCR === 'Dr' || openingBalanceDRCR === 'DR') ? openingBalance : -openingBalance;

        return transactions.map((transaction) => {
            const credit = Number(transaction.creditAmount) || '';
            const debit = Number(transaction.debitAmount) || '';

            runningBalance -= credit;
            runningBalance += debit;

            return {
                ...transaction,
                creditAmount: (credit === '' && debit === '') ? 0 : credit,
                debitAmount: (credit === '' && debit === '') ? 0 : debit,
                runningBalance: Math.abs(runningBalance),
                runningBalanceDRCR: runningBalance >= 0 ? 'Dr' : 'Cr'
            };
        });
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details },
        );
    };
    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.filterDetails;
        details[drpIdentity] = selected.value;
        this.setState({ filterDetails: details }, () => {
            this.getPartyDetailsById(this.state.filterDetails.partyId)
        });
    };

    getPartyDetailsById = (id) => {
        this.itemMasterServices.getPartyDetailsById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.filterDetails;
                let res = response.responseData
                details.openingBalance = res.openBalance
                details.email = res.email
                details.telephone = res.telephone
                details.mobileNo = res.mobileNo1
                details.openingBalanceDRCR = res.openBalanceDRCR ? res.openBalanceDRCR : "Dr"
                this.setState({ filterDetails: details });
            } else {
                this.SwalServices.Error(response.Message)
            }
        });
    };

    render() {
        return (
            <div className='AccountLedger-page'>
                <div className="item-search flex gap-2.5 !mb-2.5">
                    <div className="input-grp w-full" >
                        <label>Start Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")}
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.startDate}
                        /> */}
                    </div>
                    <div className="input-grp w-full">
                        <label>End Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                            type="date"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            value={this.state.filterDetails.endDate}
                            onChange={(event) =>
                                this.handleChange(event, "endDate")}
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.endDate}
                        /> */}
                    </div>
                    <div className="input-grp min-w-[40%]">
                        <label>Party Name</label>
                        <MultiSelectDropdown
                            drpIdentity="partyId"
                            className={`inputFocus ${this.state.validState?.error?.partyId ? "errorInput" : ""}`}
                            options={this.state.partyDropdownList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                this.setFilterParameters(selected, "partyId")}
                            allowSelectAll={false}
                            value={this.state.partyDropdownList.filter(
                                (party) =>
                                    party.value === this.state.filterDetails.partyId
                            )}
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.partyId}
                        /> */}
                    </div>
                    <div className="input-grp w-full" >
                        <label>Opening Balance</label>
                        <input
                            className="inputFocus"
                            type="text"
                            id="openingBalance"
                            name="openingBalance"
                            disabled
                            autoComplete="off"
                            value={this.state.filterDetails.openingBalance + ' ' + this.state.filterDetails.openingBalanceDRCR}
                            onChange={(event) =>
                                this.handleChange(event, "openingBalance")}
                        />
                    </div>
                </div>

                <div className="item-search flex gap-2.5 !mb-3.5">
                    <div className="input-grp min-w-[30%]" >
                        <label>E-Mail</label>
                        <input
                            className="inputFocus"
                            type="text"
                            id="email"
                            name="email"
                            autoComplete="off"
                            disabled
                            value={this.state.filterDetails.email}
                            onChange={(event) =>
                                this.handleChange(event, "email")}
                        />
                    </div>
                    <div className="input-grp w-full" >
                        <label>Telephone</label>
                        <input
                            className="inputFocus"
                            type="number"
                            id="telephone"
                            name="telephone"
                            autoComplete="off"
                            disabled
                            value={this.state.filterDetails.telephone}
                            onChange={(event) =>
                                this.handleChange(event, "telephone")}
                        />
                    </div>
                    <div className="input-grp w-full" >
                        <label>Mobile No.</label>
                        <input
                            className="inputFocus"
                            type="number"
                            id="mobileNo"
                            name="mobileNo"
                            autoComplete="off"
                            disabled
                            value={this.state.filterDetails.mobileNo}
                            onChange={(event) =>
                                this.handleChange(event, "mobileNo")}
                        />
                    </div>
                    <div className="btn-grp mt-auto">
                        <button
                            className="add-btn mt-auto"
                            onClick={() => this.getAllAccountLedger()}>
                            Search
                        </button>
                        <button
                            className="cancel-btn mt-auto"
                            onClick={() => this.resetForm()}>
                            Cancel
                        </button>
                        <button
                            className="print-btn mt-auto"
                            disabled={this.state.accountLedgerList.length > 0 ? false : true}
                            onClick={() => printFunction()}
                        >
                            Print
                        </button>
                        <button
                            className="search-btn mt-auto"
                            disabled={this.state.accountLedgerList.length > 0 ? false : true}
                            onClick={() => this.getAllAccountLedger()}>
                            Email
                        </button>
                    </div>
                </div>
                <div>
                    <div className='hidden'>
                        <h4>Account Ledger</h4>
                    </div>
                    <div class="item-listing" >
                        <div class="itemList-table">
                            <div class="table-container" style={{ height: "calc(100vh - 295px)" }} >
                                <table class="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[10%] print-w-10'>Voucher No</td>
                                            <td className='w-[10%] print-w-10'>Date</td>
                                            <td className='w-[10%] print-w-10'>Book</td>
                                            <td className='w-[25%] print-w-25'>Narration</td>
                                            <td className='w-[15%] print-w-15'>Debit</td>
                                            <td className='w-[15%] print-w-15'>Credit</td>
                                            <td className='w-[15%] print-w-15 !text-center'>Running Balance</td>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.accountLedgerList
                                            && this.state.accountLedgerList.length > 0 ? (
                                            this.state.accountLedgerList.map((details, key) => (
                                                <>
                                                    <tr
                                                        key={key}
                                                        className="hover:bg-gray-200"
                                                    >
                                                        <td>{details.voucherNo}</td>
                                                        <td>{moment(details.date).format('DD-MM-YYYY')}</td>
                                                        <td>{details.bankId?.shortName ? details.bankId?.shortName : ''}</td>
                                                        <td>{details.narration1 + details.narration2 + details.narration3}</td>
                                                        <td>{details.debitAmount}</td>
                                                        <td>{details.creditAmount}</td>
                                                        <td className='!text-center'>{details.runningBalance + ' ' + details.runningBalanceDRCR}</td>
                                                    </tr>
                                                    <tr className='last-row hidden'>
                                                        <td className='center' colSpan={4}>Total</td>
                                                        <td>{this.state.totalDebitAmount}</td>
                                                        <td>{this.state.totalCreditAmount}</td>
                                                        <td>{this.state.closingBalance}</td>
                                                    </tr>
                                                </>
                                            ))
                                        ) : this.state.accountLedgerList
                                            && this.state.accountLedgerList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.accountLedgerList
                                            && this.state.accountLedgerList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="item-sections no-print w-[65%] rounded-[10px] ml-auto mt-3 !p-3  !bg-white " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                        <div className='flex gap-2.5 '>
                            <div className=" w-full">
                                <label>Total Debit</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="totalDebit"
                                    name="totalDebit"
                                    autocomplete="off"
                                    disabled
                                    value={this.state.totalDebitAmount}
                                />
                            </div>
                            <div className=" w-full">
                                <label>Total Credit</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="totalCredit"
                                    name="totalCredit"
                                    autocomplete="off"
                                    disabled
                                    value={this.state.totalCreditAmount}
                                />
                            </div>
                            <div className=" w-full">
                                <label>Total Closing Balance</label>
                                <input
                                    className='h-[36px]'
                                    type="text"
                                    id="totalCloseBal"
                                    name="totalCloseBal"
                                    autocomplete="off"
                                    disabled
                                    value={this.state.closingBalance}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Material Requirment Report [PM]</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            Start Date: <strong>{this.state.filterDetails.startDate}</strong><br />
                                            End Date: <strong>{this.state.filterDetails.endDate}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                                              <div>
                                                                <span className="info-label">Item Name:</span>
                                                                <p className="info-value">Paracetamol</p>
                                                              </div>
                                                            </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "25%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "15%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Voucher No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Date
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Book
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Narration
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Debit
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Credit
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Running Balance
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.accountLedgerList
                                    && this.state.accountLedgerList.length > 0 ?
                                    this.state.accountLedgerList.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.voucherNo}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {moment(details.date).format('DD-MM-YYYY')}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.bankId?.shortName ? details.bankId?.shortName : ''}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.narration1 + details.narration2 + details.narration3}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.debitAmount}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.creditAmount}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.runningBalance + ' ' + details.runningBalanceDRCR}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                            <tfoot>
                                <tr style={{ backgroundColor: '#f5f5f5' }}>
                                    <td colSpan="4" style={{ textAlign: 'left', fontWeight: 'bold' }}>

                                    </td>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        <span style={{ fontSize: "7px", color: "#444", fontWeight: "500", lineHeight: "12px" }}>Total Debit</span><br />
                                        {this.state.totalDebitAmount}
                                    </td>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        <span style={{ fontSize: "7px", color: "#444", fontWeight: "500", lineHeight: "12px" }}>Total Credit</span><br />
                                        {this.state.totalCreditAmount}
                                    </td>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        <span style={{ fontSize: "7px", color: "#444", fontWeight: "500", lineHeight: "12px" }}>Closing Balance</span><br />
                                        {this.state.closingBalance}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default AccountLedger;